export const MFullWidthButtonColor = {
  containerBg: '#000000',
  containerBgDisabled: '#E5E5E8',
  label: '#FFFFFF',
  labelDisabled: '#A9A9AD',
};
